import React, { useEffect, useState } from 'react';
import { MultiSelect } from "react-multi-select-component";
import { ToastContainer, toast } from "react-toastify";
import { Modal } from 'react-bootstrap';
import { GetAllExamRules, GetAllExams, GetAllSubjects, saveExamRules, updateExamRules } from '../../../../services/CommonService';
import { log } from 'util';

function AddExamRules({ updateprop }) {

    const notifyTopFullWidth = (message) => {
        toast.info(message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,

        });
    };
    const fields = {
        position: '',
        examid: '',
        subRules: [],
        repeatquestions: "",
        Rulename: '',

    }

    const errors = {
        position: '',
        examid: '',
        totalquestions: '',
        subRules: [],
        repeatquestions: "",
        Rulename: '',

    }

    const fields2 = {
        subjectid: '',
        low: '',
        medium: "",
        high: "",



    }
    useEffect(() => {
        getExams()
        // getSubjects()
        if (updateprop?.id) {
            setFromFields(updateprop);
            setData(updateprop.subRules)
            setExamName(updateprop.examid)

        }

    }, [])
    const [examName,setExamName]=useState([])
    const [formfields, setFromFields] = useState(fields);
    const [errorFields, setErrorFields] = useState(errors);
    const [exams, setExams] = useState([])
    const [postModal, setPostModal] = useState(false);
    const [subjectfields, setSubjectFields] = useState(fields2)
    const [data, setData] = useState([]);
    const [sname, setSname] = useState([])
    const [subject, setSubject] = useState([])

    useEffect(()=>{
        getSubjects()
    },[examName])

    const { examid, position, totalquestions, subjects, repeatquestions, Rulename, } = formfields;

    const { subjectid, low, medium, high } = subjectfields
    const getExams = async () => {
        const reqparams = {
            pageno: '-1',
            query: { status: "Active" }
        }
        const ResponseData = await GetAllExams(reqparams)
        // console.log("Examsss data", ResponseData.data);
        setExams(ResponseData.data)
    }

    const getSubjects = async () => {

        const reqparams = {
            pageno: '-1',
            query: { status: "Active", _id: examName }
        }
        const ResponseData = await GetAllExams(reqparams)
        // console.log("to get subjects data", ResponseData.data);
        setSubject(ResponseData.data)

    }


    const validateForm = async () => {
        let fields = formfields;
        let errors = {};
        let formIsValid = true;

        if (!fields["position"]) {
            formIsValid = false;
            errors["position"] = "*Please enter display position name .";
        }

        if (!fields["examid"]) {
            formIsValid = false;
            errors["examid"] = "*Please enter  examid .";
        }
        // if (!fields["difficultylevel"]) {
        //     formIsValid = false;
        //     errors["difficultylevel"] = "*Please select difficultylevel.";
        // }
        if (!fields["Rulename"]) {
            formIsValid = false;
            errors["Rulename"] = "*Please enter Rulename .";
        }
        // if (!fields["totalquestions"]) {
        //     formIsValid = false;
        //     errors["totalquestions"] = "*Please enter totalquestions .";
        // }


        // if (!fields["rules"]) {
        //     formIsValid = false;
        //     errors["rules"] = "*Please select rules.";
        // }
        if (!fields["repeatquestions"]) {
            formIsValid = false;
            errors["repeatquestions"] = "*Please select repeatquestions .";
        }

        setErrorFields(errors)
        return formIsValid;

    }

    const handleChange = async (e) => {
        const { name, value } = e.target;

        if (name == "examid") {
          
            setExamName(value)

        }

        setFromFields((prevState) => ({
            ...prevState,
            [name]: value
        }));

    }

    const addSubjects = () => {
        setPostModal(true)

    }
    const closemodal = () => {
        setSubjectFields("")
        setPostModal(false)

    }

    const handleSubjects = async (e) => {
        const { name, value } = e.target;



        if (name == 'subjectid') {
            // console.log(value, "valueee");
            const reqdata = {
                pageno: "-1",
                query: {
                    status: "Active",
                    // subjectid: value ,
                    topics: { $elemMatch: { "subjectid": value } }
                }
            }
            const ResponseData = await GetAllExams(reqdata)
            ResponseData.data?.map((ele) => {
                return ele.topics.map((item) => {
                    if (item.subjectid == value) {
                        // console.log("Sname", item.name);
                        setSname(item.name)
                    }
                })
            })
        }

        setSubjectFields((prevState) => ({
            ...prevState,
            [name]: value,
            Subjectname: sname
        }));



    }
    const submitSubjects = async () => {

        // console.log("subject fields", subjectfields);
        setData([...data, subjectfields])
        setSubjectFields("")
        setPostModal(false)

    }

    const deleteRow =  (index) => {
        
        // console.log("index", index);

        const updatedItems = data.filter((_, i) => i !== index);
        // console.log("updated items",updatedItems);
        setData(updatedItems);

        // const updatedRows = [...data];
        // updatedRows.splice(index, 1);
        // setData(updatedRows)

    }

    const submitForm = async () => {
        // console.log(formfields);
        const isValid = await validateForm();

        if (isValid) {
            formfields.subRules = data;
            if (!formfields.id) {
                //save
                const Response = await saveExamRules(formfields);
                if (Response.data.id) {
                    notifyTopFullWidth("Data saved successfully");
                    formfields.id = Response.data.id;
                }

            } else {
                //update

                const Response = await updateExamRules(formfields);
                if (Response.data.id) {
                    notifyTopFullWidth("Data updated successfully");
                    formfields.id = Response.data.id;
                }
            }

        }

    }
    return (
        <>
           
            <div className="form-group mb-3 row">
                <label
                    className="col-lg-4 col-form-label"
                    htmlFor="val-username"
                >
                    Display Position
                </label>
                <div className="col-lg-6">
                    <input component="input"
                        placeholder="Display Order"
                        name="position"
                        className="form-control"

                        value={position} maxLength={50} onChange={handleChange} />

                </div>
                <div className="errorMsg">{errorFields.position}</div>
            </div>

            <div className="form-group mb-3 row">
                <label
                    className="col-lg-4 col-form-label"
                    htmlFor="val-username"
                >
                    Rule Name
                </label>
                <div className="col-lg-6">
                    <input component="input"
                        placeholder="Rule Name"
                        name="Rulename"
                        className="form-control"

                        value={Rulename} maxLength={50} onChange={handleChange} />

                </div>
                <div className="errorMsg">{errorFields.Rulename}</div>
            </div>
            <div className="form-group mb-3 row">
                <label
                    className="col-lg-4 col-form-label"
                    htmlFor="val-username"
                >
                    Exam Name
                </label>
                <div className="col-lg-6">
                    <select
                        className="form-control"
                        name="examid"
                        onChange={handleChange}
                        value={examid}
                    >
                        <option value="">Select Exam</option>
                        {exams?.map(item => (
                            <option
                                key={item.id}
                                value={item.id}
                            >
                                {item.examname}
                            </option>
                        ))}
                    </select>

                </div>
                <div className="errorMsg">{errorFields.examid}</div>
            </div>


            <div className="form-group mb-3 row">
                <label
                    className="col-lg-4 col-form-label"
                    htmlFor="val-username"
                >
                    Repeat Questions
                </label>
                <div className="col-lg-6">
                    <select
                        className="form-control" name='repeatquestions'
                        onChange={handleChange} value={repeatquestions}>
                        <option value="">Select Below</option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                    </select>

                </div>
                <div className="errorMsg">{errorFields.repeatquestions}</div>
            </div>

            <div className="form-group">
                <button onClick={addSubjects} className="btn btn-primary" type="button"
                >Add Subjects</button>
            </div>

            {data?.length > 0 && <table class="table">
                <thead>
                    <tr>
                        <th scope="col">Subject Name</th>
                        <th scope="col">Low Level</th>
                        <th scope="col">Medium Level</th>
                        <th scope="col">High Level</th>
                    </tr>
                </thead>
                <tbody>
                    {data?.map((row, index) => (
                        <tr key={row.id}>
                            <td>{row.Subjectname}</td>
                            <td>{row.low}</td>
                            <td>{row.medium}</td>
                            <td>{row.high}</td>
                            <td>
                                <label style={{border:"1px solid black"}} onClick={() => deleteRow(index)}>Delete</label>
                            </td>
                        </tr>
                    ))}

                </tbody>
            </table>}
            <br />

            <div className="form-group">
                <button onClick={submitForm} className="btn btn-primary" type="button"
                >Save</button>
            </div>

            <Modal className="modal fade" size="xl" show={postModal} onHide={setPostModal} >
                <div className="" role="document">
                    <div className="">
                        <form >
                            <div className="modal-header">

                                <button type="button" className="btn-close" onClick={closemodal} data-dismiss="modal"></button>
                            </div>
                            <div className="modal-body">
                                <div className="form-group mb-3 row">
                                    <label className="col-lg-4 col-form-label"
                                        htmlFor="val-username">
                                        Select Subjects
                                    </label>
                                    <div className="col-lg-6">
                                        <select
                                            className="form-control"
                                            name="subjectid"
                                            onChange={handleSubjects}
                                            value={subjectid}
                                        >
                                            <option value="">Select Subjects</option>
                                            {subject?.map(item => {
                                                // return (
                                                //     <option
                                                //         key={item.id}
                                                //         value={item.id}
                                                //     >
                                                //         {item.name}
                                                //     </option>
                                                // )

                                                return (
                                                    item.topics.map((ele, ind) => {
                                                        return (<option
                                                            key={ele.id}
                                                            value={ele.subjectid}
                                                        >
                                                            {ele.name}
                                                        </option>)
                                                    }

                                                    )
                                                )


                                            }

                                            )}
                                        </select>
                                    </div>

                                    <div className="errorMsg">{errorFields.subjects}</div>
                                </div>
                                <div className="form-group mb-3 row">
                                    <label
                                        className="col-lg-4 col-form-label"
                                        htmlFor="val-username"
                                    >
                                        Low level
                                    </label>
                                    <div className="col-lg-6">
                                        <input component="input"
                                            placeholder="Low level Questions"
                                            name="low"
                                            className="form-control"

                                            value={low} maxLength={50} onChange={handleSubjects} />

                                    </div>
                                    <div className="errorMsg">{errorFields.position}</div>
                                </div>



                                <div className="form-group mb-3 row">
                                    <label
                                        className="col-lg-4 col-form-label"
                                        htmlFor="val-username"
                                    >
                                        Medium Level
                                    </label>
                                    <div className="col-lg-6">
                                        <input component="input"
                                            placeholder="medium level questions"
                                            name="medium"
                                            className="form-control"

                                            value={medium} maxLength={50} onChange={handleSubjects} />

                                    </div>
                                    <div className="errorMsg">{errorFields.position}</div>
                                </div>


                                <div className="form-group mb-3 row">
                                    <label
                                        className="col-lg-4 col-form-label"
                                        htmlFor="val-username"
                                    >
                                        High Level
                                    </label>
                                    <div className="col-lg-6">
                                        <input component="input"
                                            placeholder="high level questions"
                                            name="high"
                                            className="form-control"

                                            value={high} maxLength={50} onChange={handleSubjects} />

                                    </div>
                                    <div className="errorMsg">{errorFields.position}</div>
                                </div>

                                <div className="form-group">
                                    <button onClick={submitSubjects} className="btn btn-primary" type="button"
                                    >Save Subjects</button>
                                </div>
                            </div>


                        </form>

                    </div>
                </div>
            </Modal>

        </>
    )
}

export default AddExamRules